import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Events } from 'ionic-angular';
import { SBSuiteEvents } from '../models/sbsuite.events';
import { Geolocation } from '@ionic-native/geolocation';

//Providers
import { TranslateService } from '@ngx-translate/core';
import { RequestService } from './request.service'
import { SBSuite } from '../models/sbsuite.model';

import moment from 'moment';
import { ClockIn } from '../models/clock-in.model';
import { User } from '../models/user.model';
import { Params } from '../models/params.model';

//RxJS
import { BehaviorSubject, ReplaySubject, Observable } from 'rxjs';
import { ProductsModal } from '../../../pages/product/products.modal';

/**
 * Contiene la configuración per defecto de la aplicación.
 */
export const DEFAULT_SETTINGS = {
	lang: 'es'
}

/**
 * Servicio encargado de manejar el estado del SBSuite
 *
 * @export
 * @class SBSuiteManager
 */
@Injectable()
export class SBSuiteManager {

	/**
	 * Contiene el usuario actual.
	 *
	 * @type {User}
	 * @memberof SBSuiteManager
	 */
	user: User = new User();

	/**
	 * Contiene el modelo de datos de SBSuite.
	 *
	 * @type {SBSuite}
	 * @memberof SBSuiteManager
	 */
	sbSuite: SBSuite = new SBSuite();

	/**
	 * Contiene el reloj del sistema.
	 *
	 * @type {string}
	 * @memberof SBSuiteManager
	 */
	clockTime: string = '00:00:00';

	/**
	 * Contiene el tiempo transcurrido de la fichada actual.
	 *
	 * @type {string}
	 * @memberof SBSuiteManager
	 */
	chronometer: string = '';

	/**
	 * Contiene la referencia al setInterval que actualiza el cronómetro.
	 *
	 * @type {*}
	 * @memberof SBSuiteManager
	 */
	chronoInterval: any = null;

	/**
	 * Indica si el usuario es administrador.
	 *
	 * @type {boolean}
	 * @memberof SBSuiteManager
	 */
	isAdmin: boolean = true;

	/**
	 * Indica si el usuario se ha autenticado.
	 *
	 * @type {boolean}
	 * @memberof SBSuiteManager
	 */
	isAuth: boolean = false;

	/**
	 * Indica si la aplicación está iniciada.
	 *
	 * @TODO: Revisar si es necesario.
	 *
	 * @type {boolean}
	 * @memberof SBSuiteManager
	 */
	isLoaded: boolean = false;


	/**
	 * Contiene la configuración general de la aplicación.
	 *
	 * @type {*}
	 * @memberof SBSuiteManager
	 */
	settings: any = {lang: 'es'};

	/**
	 * Indica si la plataforma está completamente cargada (platform.ready()).
	 *
	 * @TODO: Revisar si es necesario.
	 *
	 * @type {boolean}
	 * @memberof SBSuiteManager
	 */
	isReady: boolean = false;


	/**
	 * Mascara de of
	 *
	 * @type {string}
	 * @memberof SBSuiteManager
	 */
	maskMO: string = new Date().getFullYear().toString().substr(-2) + 'XXXX';

	//authSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	authSubject: ReplaySubject<any>= new ReplaySubject<any>(1);


	/**
	 * Crea un instancia de SBSuiteManager.
	 *
	 * @param {Events} events Servicio de eventos de la aplicación.
	 * @param {Storage} storage Gestor de almacenamiento local.
	 * @param {Platform} platform Gestor de la plataforma.
	 * @param {RequestService} requestService Servicio de peticiones.
	 * @param {TranslateService} translateService Servicio de traducciones.
	 * @memberof SBSuiteManager
	 */
	constructor(
		public events: Events,
		public storage: Storage,
		public platform: Platform,
		public requestService: RequestService,
		public translateService: TranslateService,
		private geolocation: Geolocation
    ) {
		setInterval(()=>this.startClock(),500); //Inicia el reloj del sistema
		this.startClock();
		this.platformReady();
		this.getLogo();
	}


	/**
	 * Asigna True a la variable isReady
	 * cuando la plataforma está lista.
	 *
	 * @memberof SBSuiteManager
	 */
	platformReady(){
		this.platform.ready().then(() => {
			this.isReady = true;

			//setTimeout(()=>this.listaOfsInternas(),300); //Cargamos la lista interna de OFs
			//this.getParams();

	   });
	}


	/**
	 * Inicia el reloj de la aplicación.
	 *
	 * @memberof SBSuiteManager
	 */
	startClock() {
		let today = new Date();
		let h = today.getHours();
		let m:any = today.getMinutes();
		let s:any = today.getSeconds();
		m = (m<10? '0' + m: m);
		s = s<10? '0' + s: s;
		this.clockTime = h + ":" + m + ":" + s;
	}

	/**
	 * Asigna la posicion de coordenads GPS de inicio de fichada
	 * @param position
	 */
	setCoordStart(): Promise<any> {
		return new Promise((resolve, reject) => {
			this.geolocation.getCurrentPosition().then((response) => {
				this.sbSuite.clocking.current.setCoordStart(response.coords.latitude, response.coords.longitude);
				resolve(response.coords.latitude.toString() + ',' + response.coords.longitude.toString());
			}).catch((error) => {
				console.log(`[geologalización]: ${error}`);
				reject("0,0");
			});

		});
	}

	/**
	 * Asigna la posicion de coordenads GPS de final de fichada
	 * @param position
	 */
	setCoordEnd():Promise<any> {
		return new Promise((resolve, reject) => {
			this.geolocation.getCurrentPosition().then((response) => {
				this.sbSuite.clocking.current.setCoordEnd(response.coords.latitude, response.coords.longitude);
				resolve(response.coords.latitude.toString() + ',' + response.coords.longitude.toString());
			}).catch((error) => {
				console.log(`[geologalización]: ${error}`);
				reject("0,0");
			});
		});
	}

	/**
	 * Inicia el tiempo de la fichada.
	 *
	 * @memberof SBSuiteManager
	 */
	startChronometer() {
		this.calcChronometer();
		if (!this.chronoInterval) this.chronoInterval = setInterval(() => this.calcChronometer(), 500);
	}


	/**
	 * Para el tiempo de la fichada.
	 *
	 * @memberof SBSuiteManager
	 */
	stopChronometer(){
		clearInterval(this.chronoInterval);
		this.chronoInterval = false;
		this.chronometer = '';
	}


	/**
	 * Calcula el tiempo trascurrido entre
	 * el inicio de la fichada y el tiempo actual.
	 *
	 * @memberof SBSuiteManager
	 */
	calcChronometer(){
		let diff = this.formatTime(this.secs2Time((this.sbSuite.getCurrentElapsedTime())/1000));
		this.chronometer = diff;

	}

	/**
	 * Formatea un Date a HH:mm:ss.
	 *
	 * @param {*} obj
	 * @returns
	 * @memberof SBSuiteManager
	 */
	formatTime(obj){
		var x=[];
		x.push(obj.h);
		x.push(obj.m);
		x.push(obj.s);
		return x.join(':')
	}


	/**
	 * Convierte un Integer a HH:mm:ss.
	 *
	 * @param {*} secs
	 * @returns
	 * @memberof SBSuiteManager
	 */
	secs2Time(secs) {
		var hours = Math.floor(secs / (60 * 60));
		var minutes = Math.floor(secs / 60)%60;
		var seconds = Math.floor(secs % 60);
		var obj = {
		"h": hours.toString().length === 1 ? '0' + hours : hours,
		"m": minutes.toString().length === 1 ? '0' + minutes : minutes,
		"s": seconds.toString().length === 1 ? '0' + seconds : seconds
		};
		return obj;
	}



	/**
	 * Guarda las opciones de la aplicación al almacenamiento local.
	 *
	 * @param {*} [settings={}]
	 * @returns {Object}
	 * @memberof SBSuiteManager
	 */
	setSettings(settings: any = {}): Object{
		this.settings = Object.assign(this.settings,settings);
		let p = this.storage.set('settings',this.settings).then((value)=>{});
		return p;
	}

	/**
	 * Devuelve las opciones de la app almacenadas en el almacenamiento local como Object.
	 *
	 * @returns {*}
	 * @memberof SBSuiteManager
	 */
	getSettings(): any{
		let p = this.storage.get('settings');
		return p.then((value)=>{
			if(value) this.settings = value;
			else this.settings = DEFAULT_SETTINGS;
			return this.settings;
		});
	}

	resetStoredUser(){
		this.user = new User();
		this.removeStoredUser();
	}
	removeStoredUser(){
		let p = this.storage.remove('user').then((value)=>{});
		return p;
	}
	setStoredUser(user: User = null): Promise<any>
	{
		let p = this.storage.set('user',this.user).then((value)=>{});
		return p;
	}

	getStoredUser(): Promise<any>
	{
		let p = this.storage.get('user');
		return p.then((value)=>{
			if(value) this.user = new User(value); //Inicia el usuario
			else this.user = new User();
			this.requestService.setToken(this.user.token); //Establece el token
			this.getAuth(); //Realiza la petición de validación del token
			return this.user;
		});
	}


	/**
	 * Asigna el idioma de la aplicación
	 *
	 * @param {string} [lang=this.settings.lang]
	 * @returns {String}
	 * @memberof SBSuiteManager
	 */
	setLang(lang: string = this.settings.lang): String{
		this.settings.lang = this.settings.lang;
		this.setSettings();
		this.translateService.use(this.settings.lang);
		return this.settings.lang;
	}



	/**
	 * Devuelve el idioma de la aplicación
	 *
	 * @returns {string}
	 * @memberof SBSuiteManager
	 */
	getLang(): string{
		return this.settings.lang;
	}


	/**
	 * Devuelve el historial de fichadas
	 *
	 * @returns {Array<ClockIn>}
	 * @memberof SBSuiteManager
	 */
	getHistory(): Array<ClockIn>{
		return this.sbSuite.clocking.history;
	}


	/**
	 * Devuelve la lista interna de OFs
	 *
	 * @returns {Array<ClockIn>}
	 * @memberof SBSuiteManager
	 */
	getInternalList(): Array<ClockIn>{
		return this.sbSuite.getInternalList();
	}

	/**
	 * Carga los datos de la fichada actual
	 *
	 * @memberof SBSuiteManager
	 */
	loadCurrentClockIn(): void{
		if(this.sbSuite.loadCurrent()) this.startChronometer();
	}


	/**
	 * Inicia la fichada automática:
	 *  - Primero mira si hay fichada en curso
	 *  - Sino mira si hay fichada anterior
	 *  - Inicia el cronómetro con la fecha inicio
	 *
	 * @memberof SBSuiteManager
	 */
	startClockIn(){
		this.sbSuite.clocking.current.start =  moment().format('YYYY-MM-DD HH:mm:ss');
		let mo = this.sbSuite.clocking.current.manufacturingOrder;
		let op = this.sbSuite.clocking.current.operation;
		let prod = this.sbSuite.clocking.current.products;

		let last = this.sbSuite.clocking.getLastOperatorOrder();
		if(!mo) this.sbSuite.clocking.current.manufacturingOrder = last.manufacturingOrder;
		if(!op) this.sbSuite.clocking.current.operation = last.operation;
		if(!prod) this.sbSuite.clocking.current.products = last.products;

		this.startChronometer();
	}

	setLoaded(){
		this.isLoaded = true;
		setTimeout(()=>this.events.publish(SBSuiteEvents.EVENTS.APP_LOADED,this.isLoaded,Date.now()),300);

	}

	/**
	 * Continua la fichada anterior
	 *
	 * @memberof SBSuiteManager
	 */
	continueLastClockIn(): void{
		if(this.sbSuite.continueLast()){
			this.entrarOperario();
			//this.startChronometer();
		}

	}

	/*
	 * Request wrappers
	 */



	/**
	 * Recibe el cambio de operario, procesa los datos y notifica los eventos
	 *
	 * @param {string} [code=''] El código del operador
	 * @param {string} [event='auto'] El tipo de evento a ejecutar al finalizar la petición. Opciones:
	 * 	- auto: guarda los datos en la fichada automàtica y lanza el evento para pedir los datos de fabricación
	 *  - unauto: guarda los datos en la fichada automàtica y no propaga el evento
	 *  - manually: guarda los datos en la fichada manual y consulta los datos de historial
	 * @memberof SBSuiteManager
	 */
	cambiarOperario(code: string = '', event: string = 'auto'){
		if(!code) return;
		this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OPERARIO_INIT,code,Date.now());
		this.requestService.cambiarOperario(code).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OPERARIO_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.operario(code,event); //Consulta el nombre del usuario
					try{
						if(event == 'auto'){ //Reinicia las fichadas actual y última
							this.sbSuite.getCurrent().reset();
							this.sbSuite.getLast().reset();

						}
						if(event != 'manually'){
							this.sbSuite.setCurrentLastResponse(code, result.getData());

							//Consulta los productos y operaciones relacionadas
							if(this.sbSuite.getCurrent().products.length>0)this.getDropdowns(this.sbSuite.getCurrent().manufacturingOrder,this.sbSuite.getCurrent().products[0].code,'auto');

						}
						else this.sbSuite.manuallyOperator = code;
					}
					catch(e){
						this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OPERARIO_FAIL,e,Date.now());
					}

					this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OPERARIO_END,result.getData(),Date.now());

					if(event=='manually'){ //Si és una petición de fichada manual
						let data = result.getData();
						this.sbSuite.manuallyName = '';
						if(data.length && data[0]){ //Guarda el nombre del operario
							if(typeof data[0].nombre_operario) this.sbSuite.manuallyName = data[0].nombre_operario;
						}
						this.getOfsOperario(this.sbSuite.manuallyOperator, this.sbSuite.getRequestDate());
					}
					else{ //Sino detecta si existe fichada actual/última o no
						this.sbSuite.clocking.saveCurrent();
						if(!this.sbSuite.isCurrentEmpty()){
							this.events.publish(SBSuiteEvents.EVENTS.CURRENT_OF_DETECTED, result.getData()[0], Date.now());
						}
						else if(!this.sbSuite.isLastEmpty()){
							this.events.publish(SBSuiteEvents.EVENTS.LAST_OF_DETECTED, result.getData()[1], Date.now());
						}
						else{
							this.events.publish(SBSuiteEvents.EVENTS.NO_OF_DETECTED, null, Date.now());
						}
					}
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OPERARIO_FAIL,error,Date.now());
			}

		)

	}


	/**
	 * Recibe los datos de cambioOf, procesa los datos y notifica los eventos
	 *
	 * @param {string} [code=''] El código de la operación
	 * @param {string} [operator=this.sbSuite.getCurrentOperator()] El código del operador
	 * @memberof SBSuiteManager
	 */
	cambiarOf(code: string = '', operator: string = this.sbSuite.getCurrentOperator()){
		this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OF_INIT,code,Date.now());
		this.setCoordEnd().then(
			(value) => {
				this.requestService.cambiarOf(code, operator, value).subscribe(
					result=>{
						if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OF_FAIL,result.getErrorMessage(),Date.now());
						else{
							//Establece fichada actual y última
							this.sbSuite.setCurrentLastResponse(operator, result.getData(),{_relatedOperations: this.sbSuite.getCurrentRelatedOperations()});
							//Consulta los productos y operaciones relacionadas
							this.getDropdowns(this.sbSuite.getCurrent().manufacturingOrder,this.sbSuite.getCurrent().products[0].code,'auto');
		
							this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OF_END,result.getData(),Date.now());
						}
					},
					error=>{
						this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OF_FAIL,error,Date.now());
					}
				)
			}
		).catch( // Per si falla
			function(){
				this.requestService.cambiarOf(code, operator, '0,0').subscribe(
					result=>{
						if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OF_FAIL,result.getErrorMessage(),Date.now());
						else{
							//Establece fichada actual y última
							this.sbSuite.setCurrentLastResponse(operator, result.getData(),{_relatedOperations: this.sbSuite.getCurrentRelatedOperations()});
							//Consulta los productos y operaciones relacionadas
							this.getDropdowns(this.sbSuite.getCurrent().manufacturingOrder,this.sbSuite.getCurrent().products[0].code,'auto');
		
							this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OF_END,result.getData(),Date.now());
						}
					},
					error=>{
						this.events.publish(SBSuiteEvents.EVENTS.CAMBIAR_OF_FAIL,error,Date.now());
					}
				)
			}
		);
	}



	/**
	 * Recibe los datos de entrarOperario, procesa los datos y notifica los eventos
	 *
	 * @param {string} [operator=this.sbSuite.currentOperator] El código del operador
	 * @memberof SBSuiteManager
	 */
	entrarOperario(operator: string = this.sbSuite.currentOperator){
		this.events.publish(SBSuiteEvents.EVENTS.CONTINUE_OF_INIT);
		/* Consulta de las coordenadas al abrir*/
		this.setCoordStart().then(
			(value) => {
				this.requestService.entrarOperario(operator, value).subscribe(
					result=>{
						if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.CONTINUE_OF_FAIL,result.getErrorMessage(),Date.now());
						else{
							//Establece la primera y última fichada
							this.sbSuite.setCurrentLastResponse(operator, result.getData());
							//Consulta los productos y operaciones ralacionadas
							this.getDropdowns(this.sbSuite.getCurrent().manufacturingOrder,this.sbSuite.getCurrent().products[0].code,'auto');
							this.events.publish(SBSuiteEvents.EVENTS.CONTINUE_OF_END,result.getData(),Date.now());
						}
					},
					error=>{
						this.events.publish(SBSuiteEvents.EVENTS.CONTINUE_OF_FAIL,error,Date.now());
					}
				)
			}
		).catch( // Per si falla
			function(){
				console.log('falla');
				this.requestService.entrarOperario(operator, '0,0').subscribe(
					result=>{
						if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.CONTINUE_OF_FAIL,result.getErrorMessage(),Date.now());
						else{
							//Establece la primera y última fichada
							this.sbSuite.setCurrentLastResponse(operator, result.getData());
							//Consulta los productos y operaciones ralacionadas
							this.getDropdowns(this.sbSuite.getCurrent().manufacturingOrder,this.sbSuite.getCurrent().products[0].code,'auto');
							this.events.publish(SBSuiteEvents.EVENTS.CONTINUE_OF_END,result.getData(),Date.now());
						}
					},
					error=>{
						this.events.publish(SBSuiteEvents.EVENTS.CONTINUE_OF_FAIL,error,Date.now());
					}
				)
			}
		);
	}

	/**
	 * Recibe los datos de salirOperario, procesa los datos y notifica los eventos
	 *
	 * @param {string} [operator=this.sbSuite.currentOperator] El código del operador
	 * @memberof SBSuiteManager
	 */
	salirOperario(operator: string = this.sbSuite.currentOperator){
		this.events.publish(SBSuiteEvents.EVENTS.EXIT_OPERATOR_INIT);
		/* Consulta de las coordenadas al cerrar */
		this.setCoordEnd().then(
			(value) => {
				this.requestService.salirOperario(operator, value).subscribe(
					result => {
						if (result.isError()) {
							if (result.getErrorMessage() == "Este operario ya no tiene ninguna fichada activa") this.sbSuite.clocking.current.reset();
							this.events.publish(SBSuiteEvents.EVENTS.EXIT_OPERATOR_FAIL, result.getErrorMessage(), Date.now());
						}
						else {
							this.events.publish(SBSuiteEvents.EVENTS.EXIT_OPERATOR_END, result.getData(), Date.now());
						}
					},
					error => {
						this.events.publish(SBSuiteEvents.EVENTS.EXIT_OPERATOR_FAIL, error, Date.now());
					}
				)
			}
		).catch( // Per si falla
			function(){
				console.log('falla');
				this.requestService.salirOperario(operator, '0,0').subscribe(
					result => {
						if (result.isError()) {
							if (result.getErrorMessage() == "Este operario ya no tiene ninguna fichada activa") this.sbSuite.clocking.current.reset();
							this.events.publish(SBSuiteEvents.EVENTS.EXIT_OPERATOR_FAIL, result.getErrorMessage(), Date.now());
						}
						else {
							this.events.publish(SBSuiteEvents.EVENTS.EXIT_OPERATOR_END, result.getData(), Date.now());
						}
					},
					error => {
						this.events.publish(SBSuiteEvents.EVENTS.EXIT_OPERATOR_FAIL, error, Date.now());
					}
				)
			}
		);


	}


	/**
	 * Recibe los datos de listaOfsInternas, procesa los datos y notifica los eventos
	 *
	 * @memberof SBSuiteManager
	 */
	listaOfsInternas(){
		this.events.publish(SBSuiteEvents.EVENTS.INTERNAL_LIST_INIT);
		this.requestService.listaOfsInternas().subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.INTERNAL_LIST_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.sbSuite.setInternalListFromResponse(result.getData());
					this.events.publish(SBSuiteEvents.EVENTS.INTERNAL_LIST_END,result.getData(),Date.now());
				}
			},
			error=>{
				this.events.publish(SBSuiteEvents.EVENTS.INTERNAL_LIST_FAIL,error,Date.now());
			}
		)

	}

	/**
	 * Recibe los datos de getOfsOperario, procesa los datos y notifica los eventos
	 *
	 * @param {string} [operator=''] El código del operador
	 * @param {string} [date=''] La fecha en formato YYYY-MM-DD
	 * @memberof SBSuiteManager
	 */
	getOfsOperario(operator: string = '', date: string =''){
		this.events.publish(SBSuiteEvents.EVENTS.HISTORY_INIT,operator,Date.now());
		this.requestService.getOfsOperario(operator, date).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.HISTORY_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.sbSuite.setHistoryFromResponse(result.getData());
					this.events.publish(SBSuiteEvents.EVENTS.HISTORY_END,result.getData(),Date.now());
					if(!result.getData().length) this.events.publish(SBSuiteEvents.EVENTS.HISTORY_FAIL,'EMPTY_HISTORY',Date.now());
				}
			},
			error=>{
				this.events.publish(SBSuiteEvents.EVENTS.HISTORY_FAIL,error,Date.now());
			}
		)
  }

  /**
	 * Recibe los datos de getInformeTest, procesa los datos y notifica los eventos
	 *
	 * @param {string} [date1=''] La fecha en formato YYYY-MM-DD
   * @param {string} [date2=''] La fecha en formato YYYY-MM-DD
	 * @memberof SBSuiteManager
	 */
  getInformeTest(date1: string ='', date2: string = ''): Observable<any>{
    //this.events.publish(SBSuiteEvents.EVENTS.HISTORY_INIT,Date.now(),Date.now());
		return this.requestService.getInformeTest(date1, date2);
  }

	/**
	 * Recibe los datos de getProductosOfDropdown, procesa los datos y notifica los eventos	 *
	 *
	 * @param {string} [of='']
	 * @param {strin} [event='auto'] El tipo de evento a ejecutar al finalizar la petición. Opciones:
	 * 	- auto: guarda los datos en la fichada automàtica y lanza el evento para abrir la selección de producto
	 *  - unauto: guarda los datos en la fichada automàtica y realiza la petición para obtener las operaciones
	 *  - manually: guarda los datos en la fichada manual y realiza la petición para obtener las operaciones
	 *  - unmanually: guarda los datos en la fichada manual y realiza la petición para obtener las operaciones
	 * @memberof SBSuiteManager
	 */
	getProductosOfDropdown(of:string = '', event: string = 'auto'){
		this.events.publish(SBSuiteEvents.EVENTS.PRODUCTO_OF_INIT,of,Date.now());
		this.requestService.getProductosOfDropdown(of).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.PRODUCTO_OF_FAIL,result.getErrorMessage(),Date.now());
				else{
					if(event == 'auto'){ //Assigna los productos relacionados a la fichada actual
						//Assigna la of consultada
						this.sbSuite.getCurrent().manufacturingOrder = of;
						this.sbSuite.setCurrentRelatedProducts(result.getData());
						this.events.publish(SBSuiteEvents.EVENTS.PRODUCTO_OF_END,this.sbSuite.getCurrent(),Date.now());
					}
					else if(event == 'manually'){ //Assigna los productos relacionados a la fichada manual
						this.sbSuite.getManually().manufacturingOrder = of;
						this.sbSuite.setManuallyRelatedProducts(result.getData());
						this.events.publish(SBSuiteEvents.EVENTS.PRODUCTO_OF_END,this.sbSuite.getManually(),Date.now());
					}
					else if(event == 'unmanually'){
						this.sbSuite.getManually().manufacturingOrder = of;
						this.sbSuite.setManuallyRelatedProducts(result.getData());
						this.events.publish(SBSuiteEvents.EVENTS.PRODUCTO_OF_END,null,Date.now());

					}
					else console.warn('SBSuiteManager.getProductosOfDropdown: Implement more events');
				}
			},
			error=>{
				this.events.publish(SBSuiteEvents.EVENTS.PRODUCTO_OF_FAIL,'Error al recuperar los productos' + error.name,Date.now());
			}
		)
	}

	/**
	 * Recibe los datos de getOpsProdOfDropdown, procesa los datos y notifica los eventos
	 *
	 * @param {string} [product=''] El código del producto
	 *  @param {strin} [event='auto'] El tipo de evento a ejecutar al finalizar la petición. Opciones:
	 * 	- auto: guarda los datos en la fichada automàtica y lanza el evento para abrir la selección de operación
	 *  - unato: guarda los datos en la fichada automàtica
	 *  - unmanually: guarda los datos en la fichada manual
	 * @memberof SBSuiteManager
	 */
	getOpsProdOfDropdown(product:string = '', event: string = 'auto'){
		this.events.publish(SBSuiteEvents.EVENTS.OPERACION_PROD_INIT,product,Date.now());
		this.requestService.getOpsProdOfDropdown(product).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.OPERACION_PROD_FAIL,result.getErrorMessage(),Date.now());
				else{
					if(event == 'auto'){ //Assigna las operaciones relacionadas de la fichada actual con el producto
						this.sbSuite.setCurrentRelatedOperations(result.getData());
						this.events.publish(SBSuiteEvents.EVENTS.OPERACION_PROD_END,this.sbSuite.getCurrent(),Date.now());;
					}
					if(event == 'unauto'){ //Assigna las operaciones relacionadas de la fichada actual con el producto
						this.sbSuite.setCurrentRelatedOperations(result.getData());
						this.events.publish(SBSuiteEvents.EVENTS.OPERACION_PROD_END,null,Date.now());;
					}
					else if(event == 'manually'){ //Assigna las operaciones relacionadas de la fichada manual con el producto
						this.sbSuite.setManuallyRelatedOperations(result.getData());
						this.events.publish(SBSuiteEvents.EVENTS.OPERACION_PROD_END,this.sbSuite.getManually(),Date.now());;
					}
					else if(event == 'unmanually'){
						this.sbSuite.setManuallyRelatedOperations(result.getData());
						this.events.publish(SBSuiteEvents.EVENTS.OPERACION_PROD_END,null,Date.now());
					}
					else console.warn('SBSuiteManager.getOpsProdOfDropdown: Implement more events');
				}
			},
			error=>{
				this.events.publish(SBSuiteEvents.EVENTS.OPERACION_PROD_FAIL,'Error al recuperar las operaciones' + error.name,Date.now());
			});
	}


	/**
	 * Realiza la petición de modificación de fichada
	 *
	 * @param {ClockIn} [clockIn=new ClockIn] Fichada a modificar
	 * @memberof SBSuiteManager
	 */
	modHorasOpProdOf(clockIn: ClockIn = new ClockIn){
		this.events.publish(SBSuiteEvents.EVENTS.UPDATE_REG_INIT,clockIn,Date.now());
		this.requestService.modHorasOpProdOf(clockIn.register, clockIn.getRequestParams()).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.UPDATE_REG_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.sbSuite.setManuallyInHistory();
					this.events.publish(SBSuiteEvents.EVENTS.UPDATE_REG_END,result.getData(),Date.now());
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.UPDATE_REG_FAIL,'ERROR actualizando el registro de horas: ' + error.name ,Date.now());
			}
		);
	}

	/**
	 * Realiza la petición de añadir fichada
	 *
	 * @param {ClockIn} [clockIn=new ClockIn] Fichada a añadir
	 * @memberof SBSuiteManager
	 */
	anadirHorasOpProdOf(clockIn: ClockIn = new ClockIn): void{
		this.events.publish(SBSuiteEvents.EVENTS.CREATE_REG_INIT,clockIn,Date.now());
		this.requestService.anadirHorasOpProdOf(clockIn.getRequestParams2()).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.CREATE_REG_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.sbSuite.manually.register = result.getData().id_reg_ofsoperarios
					this.sbSuite.setManuallyInHistory();
					this.events.publish(SBSuiteEvents.EVENTS.CREATE_REG_END,result.getData(),Date.now());
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.CREATE_REG_FAIL,'ERROR creando el registro de horas: ' + error.name ,Date.now());
			}
		);
	}

	/**
	 * Realiza la petición para eliminar una fichada
	 *
	 * @param {string} [register='']
	 * @memberof SBSuiteManager
	 */
	delHorasOpProdOf(register: string = ''): void{
		this.events.publish(SBSuiteEvents.EVENTS.DELETE_REG_INIT,register,Date.now());
		this.requestService.delHorasOpProdOf(register).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.DELETE_REG_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.events.publish(SBSuiteEvents.EVENTS.DELETE_REG_END,result.getData(),Date.now());
					let index = this.sbSuite.getHistory().map(item=>item.register).indexOf(register);
					if(index!=-1) this.sbSuite.deleteIndexInHistory(index);
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.DELETE_REG_FAIL,'ERROR creando el registro de horas: ' + error.name ,Date.now());
			}
		);
	}

	/**
	 * Consulta el dropdown de producto y el dropdown de operación.
	 *
	 * @param {string} [of='']
	 * @param {string} [product='']
	 * @param {string} [event='auto']
	 * @memberof SBSuiteManager
	 */
	getDropdowns(of:string = '', product: string='', event:string = 'auto'): void{
		this.events.publish(SBSuiteEvents.EVENTS.DROPDOWNS_INIT,of,Date.now());
		this.requestService.getProductosOfDropdown(of).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.DROPDOWNS_FAIL,result.getErrorMessage(),Date.now());
				else{
					if(event == 'auto') this.sbSuite.setCurrentRelatedProducts(result.getData());
					else if (event == 'manually') this.sbSuite.setManuallyRelatedProducts(result.getData());
					this.requestService.getOpsProdOfDropdown(product).subscribe(
						result=>{
							if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.DROPDOWNS_FAIL,result.getErrorMessage(),Date.now());
							else{
								if(event == 'auto'){
									this.sbSuite.setCurrentRelatedOperations(result.getData());
									this.sbSuite.clocking.saveCurrent();
								}
								else if(event == 'manually') this.sbSuite.setManuallyRelatedOperations(result.getData());
								this.events.publish(SBSuiteEvents.EVENTS.DROPDOWNS_END,result.getData(),Date.now());
							}
						},
						error=>{
							this.events.publish(SBSuiteEvents.EVENTS.DROPDOWNS_FAIL, 'ERROR al recuperar la operación: ' + error.name, Date.now());

						}
					);
				}
			},
			error=>{
				this.events.publish(SBSuiteEvents.EVENTS.DROPDOWNS_FAIL, 'ERROR al recuperar los productos: ' + error.name, Date.now());
			}
		)
	}

	/**
	 * Consulta los parámetros de configuración del sistema.
	 *
	 * @memberof SBSuiteManager
	 */
	getParams(){
		this.events.publish(SBSuiteEvents.EVENTS.DEFINE_NEW_INIT,null,Date.now());
		this.requestService.getParams().subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.DEFINE_NEW_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.sbSuite.params = new Params(result.getData());
					this.events.publish(SBSuiteEvents.EVENTS.DEFINE_NEW_END,result.getData(),Date.now());
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.DEFINE_NEW_FAIL,'ERROR al recuperar los parámetros del sistema: ' + error.name ,Date.now());
			}
		);

	}

	/**
	 * Consulta los parámetros de configuración del sistema.
	 *
	 * @memberof SBSuiteManager
	 */
	getLogo(){
		this.events.publish(SBSuiteEvents.EVENTS.LOGIN_INIT,null,Date.now());
		this.requestService.getLogo().subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.LOGO_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.sbSuite.params.setLogo(result.getData());
					this.events.publish(SBSuiteEvents.EVENTS.LOGO_END,result.getData(),Date.now());
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.LOGO_FAIL,'ERROR al recuperar los parámetros del sistema: ' + error.name ,Date.now());
			}
		);

	}

	login(credentials: {username:string, password:string} = {username:'',password:''}){
		this.events.publish(SBSuiteEvents.EVENTS.LOGIN_INIT,null,Date.now());
		this.requestService.login(credentials).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.LOGIN_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.user = new User(result.getData());
					this.requestService.setToken(this.user.token);
					this.setStoredUser();
					this.listaOfsInternas();
					this.authSubject.next(this.user);
					this.events.publish(SBSuiteEvents.EVENTS.LOGIN_END,result.getData(),Date.now());
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.LOGIN_FAIL,'ERROR: ' + error.name ,Date.now());
			}
		);
	}

	/**
	 *  Consulta el nombre de operario
	 * @param {string} [operator=''] El código del operario
	 * 	- auto: guarda los datos en la fichada automàtica y lanza el evento para abrir la selección de operación
	 *  - manually: guarda los datos en la fichada manual
	 * @memberof SBSuiteManager
	 */
	operario(operator: string = '', event = 'auto'){
		this.events.publish(SBSuiteEvents.EVENTS.DEFINE_NEW_INIT,null,Date.now());
		this.requestService.operario(operator).subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.LOGIN_FAIL,result.getErrorMessage(),Date.now());
				else{
					if(event=='auto'){
						this.sbSuite.getCurrent().name = result.getData().nombre;
						this.sbSuite.getLast().name = result.getData().nombre;
					}
					else if(event = 'manually'){
						this.sbSuite.manuallyName = result.getData().nombre;
					}
				}
			},
			error=> {
				this.events.publish(SBSuiteEvents.EVENTS.LOGIN_FAIL,'ERROR: ' + error.name ,Date.now());
			}
		);
	}

	getAuth(){
		this.events.publish(SBSuiteEvents.EVENTS.AUTH_INIT,null,Date.now());
		this.requestService.getParams().subscribe(
			result=>{
				if(result.isError()) this.events.publish(SBSuiteEvents.EVENTS.AUTH_FAIL,result.getErrorMessage(),Date.now());
				else{
					this.authSubject.next(this.user); //Notifica el nivel de usuario actual.
					this.events.publish(SBSuiteEvents.EVENTS.AUTH_END,null,Date.now());
					this.listaOfsInternas();
					this.sbSuite.params = new Params(result.getData());
				}
			},
			error=>{
				this.events.publish(SBSuiteEvents.EVENTS.AUTH_FAIL,'ERROR: ' + error.name ,Date.now());
			}
		)
	}

	/**
	 * Devuelve uns simulación de fichadas.
	 *
	 * @TODO: Eliminar
	 *
	 * @param {string} [code=null]
	 * @returns
	 * @memberof SBSuiteManager
	 */
	getMockClockIns(code: string = null){
        return [
			{mo: '00001', product: 'Producto A datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '20/10/2018 9:00', end: '20/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00A'},
			{mo: '00002', product: 'Producto B datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '21/10/2018 9:00', end: '21/10/2018 14:00', time: 5, obs: '', qty: 0, client: 'Client00B'},
			{mo: '00003', product: 'Producto C datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '22/10/2018 9:00', end: '22/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00C'},
			{mo: '00004', product: 'Producto A datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '23/10/2018 9:00', end: '23/10/2018 14:00', time: 5, obs: '', qty: 0, client: 'Client00A'},
			{mo: '00005', product: 'Producto B datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '24/10/2018 9:00', end: '24/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00B'},
			{mo: '00006', product: 'Producto C datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '25/10/2018 9:00', end: '25/10/2018 14:00', time: 5, obs: '', qty: 0, client: 'Client00C'},
			{mo: '00007', product: 'Producto A datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '26/10/2018 9:00', end: '26/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00A'},
			{mo: '00008', product: 'Producto B datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '27/10/2018 9:00', end: '27/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00B'},
			{mo: '00000', product: 'Producto C datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '28/10/2018 9:00', end: '28/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00C'},
			{mo: '00010', product: 'Producto A datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '29/10/2018 9:00', end: '29/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00A'},
			{mo: '00011', product: 'Producto B datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '30/10/2018 9:00', end: '30/10/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00B'},
			{mo: '00012', product: 'Producto C datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '01/11/2018 9:00', end: '01/11/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00C'},
			{mo: '00013', product: 'Producto A datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '05/11/2018 9:00', end: '02/11/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00A'},
			{mo: '00014', product: 'Producto B datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '03/11/2018 9:00', end: '03/11/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00B'},
			{mo: '00015', product: 'Producto C datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '04/11/2018 9:00', end: '04/11/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00C'},
			{mo: '00016', product: 'Producto A datos para rellenar', operation: 'PUNXONAR', machine: '00002', start: '05/11/2018 9:00', end: '05/11/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00A'},
			{mo: '00017', product: 'Producto B datos para rellenar', operation: 'PUNXONAR', machine: '00001', start: '06/11/2018 9:00', end: '06/11/2018 14:00', time: 5, obs: 'observation obnservation observation', qty: 0, client: 'Client00B'},
        ]
	}
}



// WEBPACK FOOTER //
// ./src/modules/sbsuite/providers/sbsuite.manager.ts